/** Callers read `event.target.value`; `nativeEvent` is what `useEditable` checks for. */
export const changeEvent = (value) => ({
  target: { value },
  currentTarget: { value },
  nativeEvent: new Event("change"),
});
